import { AthosFetcher } from 'libs/athos/classes/athos-fetcher'
import { isAthosInstockOnly } from 'libs/athos/athos-utils'
import { normaliseResults } from 'libs/athos/helpers/normalisers'
import { generateAthosProvider } from 'libs/athos/fetchers/provider'
import type { AthosFetchOptions } from 'libs/athos/athos.types'

export class AthosCollection extends AthosFetcher {
  generateURL() {
    // PLPs use the dedicated Athos `/category` endpoint. The response shape is
    // identical to `/search`, so the `bgfilter.*` params and rendering are shared.
    return super.generateURL('/category')
  }

  updateParams(options: AthosFetchOptions = {}) {
    const { handle, originalQuery, sort, filters, page, resultsPerPage } = options

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('bgfilter.collection_handle', handle)
    // Variant-level availability constraint. Athos cross-matches filters per
    // variant, so this drops fully sold-out products AND makes the `size` facet
    // counts stock-accurate. `bgfilter.` keeps it out of `filterSummary`, so it
    // never renders as a removable pill and "Clear all" can't wipe it. Set
    // before setFilters(), which only clears keys starting with `filter`.
    if (isAthosInstockOnly()) this.params.set('bgfilter.ss_available', 1)

    if (originalQuery) this.params.set('oq', originalQuery)
    if (page) this.params.set('page', page)
    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)

    if (sort) this.params.setSort(sort); else this.params.clearSort()
    if (filters) this.params.setFilters(filters)

    super.updateParams()
  }
}

export const AthosCollectionProvider = generateAthosProvider(AthosCollection, async (results) => {
  const normalisedResults = await normaliseResults(results.results)

  return {
    ...results,
    results: normalisedResults
  }
})
